























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ExpandedItem extends Vue {
  @Prop({ required: true }) public title!: string
  @Prop({ required: false, default: false }) public initialState!: boolean
  public isExpanded = this.initialState
}
